import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { AccessKey } from 'src/features/accessKey/utils/types';

const RESOURCE = `sp-core/:parkingId/visitors/access-key/:id/`;

type QueryFnType = typeof queryFn;

interface DTO {
    id: string;
    parkingId: string;
}
const queryFn = ({ id, parkingId }: DTO): Promise<AccessKey> => {
    return axios.get(formatResourcePath(RESOURCE, { id, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as ACCESS_KEY_RESOURCE, useQueryHook as useGetAccessKey };
